import styled from "@emotion/styled";

export const Wrapper = styled.section`
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  left: 0;
  padding: 24px 0;
  bottom: 54px;
`;
